import React, { useState } from "react";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";

// FIX 1: Remove ANYTHING causing horizontal overflow
// Added: w-full overflow-x-hidden

const contactCards = [
  {
    icon: <FiMapPin className="text-[#df2313] text-3xl mx-auto mb-3" />,
    title: "Our Office",
    text: "Indore, MP",
    link: "https://www.google.com/maps",
  },
  {
    icon: <FiMail className="text-[#df2313] text-2xl mx-auto mb-3" />,
    title: "Email Us",
    text: "codexfuturetechnologies@gmail.com",
    link: "mailto:codexfuturetechnologies@gmail.com",
  },
  {
    icon: <FiPhone className="text-[#df2313] text-2xl mx-auto mb-3" />,
    title: "Call Us",
    text: "+91 93037 15744",
    link: "tel:+919303715744",
  },
];

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_fz98ect",
        "template_fyygjp7",
        {
          user_name: formData.name,
          user_email: formData.email,
          message: formData.message,
        },
        "a8Z9CQQmTYq1Zhy7j"
      )
      .then(
        () => {
          alert(`Thank you ${formData.name}, your message has been sent!`);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error("EmailJS Error:", error);
          alert("Oops! Something went wrong, please try again.");
        }
      );
  };

  return (
    <div className="relative w-full min-h-screen bg-white font-sans overflow-x-hidden">
      {/* CONTACT HERO SECTION */}
      <section className="relative w-full min-h-[55vh] sm:min-h-[50vh] flex flex-col justify-center items-center text-center px-6 bg-black overflow-x-hidden">
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-[600] mb-4 uppercase tracking-wide text-white">
          Contact Us
        </h1>

        <p className="mt-2 text-lg sm:text-xl max-w-2xl leading-relaxed text-gray-300">
          Get in touch with <strong style={{ color: "#df2313" }}>Codex Future Technologies</strong> — we are here to support your digital transformation journey.
        </p>

        <button
          onClick={() => {
            const section = document.getElementById("contact-form-section");
            if (section) section.scrollIntoView({ behavior: "smooth" });
          }}
          className="absolute bottom-[2rem] animate-bounce text-white bg-[#df2313] w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </section>

      {/* MAIN CONTACT FORM WITH CARDS */}
      <section
        id="contact-form-section"
        className="w-full bg-white py-16 px-5 overflow-x-hidden"
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-14 overflow-x-hidden">

          {/* LEFT SIDE: 3 Cards */}
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            className="flex flex-col space-y-6"
          >
            {contactCards.map((card, idx) => (
              <motion.a
                key={idx}
                href={card.link}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col items-center text-center w-full"
              >
                {card.icon}
                <h4 className="font-semibold text-lg mb-1">{card.title}</h4>
                <p className="text-gray-700 text-sm break-words">{card.text}</p>
              </motion.a>
            ))}
          </motion.div>

          {/* RIGHT SIDE FORM */}
          <motion.div
            className="bg-white p-7 md:p-10 rounded-xl shadow-2xl border border-gray-300 w-full"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h3 className="text-2xl font-semibold text-center text-black mb-6">
              Send Us a Message
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 bg-blue-50 text-black border border-gray-700 rounded-md"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 bg-blue-50 text-black border border-gray-700 rounded-md"
                required
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="5"
                className="w-full p-3 bg-blue-50 text-black border border-gray-700 rounded-md"
                required
              ></textarea>

              <motion.button
                whileHover={{ scale: 1.05 }}
                type="submit"
                className="w-full bg-[#df2313] py-3 rounded-md text-white font-medium hover:bg-black transition"
              >
                Submit Now
              </motion.button>
            </form>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;